import create from './create';
import detail from './detail';
import edit from './edit';
import list from './list';

const ApiCall = {
  list,
  detail,
  create,
  edit,
  delete: edit,
};

export default ApiCall;
